/**
 * Returns a function that checks whether a type_id belongs to the "Travel" category.
 * Replaces an identical useMemo block that was duplicated in 4 files.
 */
export function buildIsTravelType(activityTypes, activityCategories) {
  const typeToCategoryId = new Map(
    (Array.isArray(activityTypes) ? activityTypes : []).map(t => [String(t.type_id), String(t.category_id)])
  );
  const categoryIdToName = new Map(
    (Array.isArray(activityCategories) ? activityCategories : []).map(c => [String(c.category_id), String(c.category_name || '')])
  );
  return (typeId) => {
    if (!typeId) return false;
    const catId = typeToCategoryId.get(String(typeId));
    if (!catId) return false;
    return (categoryIdToName.get(String(catId)) || '').toLowerCase() === 'travel';
  };
}

/**
 * Returns a function that checks whether a category_id is the "Travel" category.
 */
export function buildIsTravelCategory(activityCategories) {
  const categoryIdToName = new Map(
    (Array.isArray(activityCategories) ? activityCategories : []).map(c => [String(c.category_id), String(c.category_name || '')])
  );
  return (categoryId) => {
    if (!categoryId) return false;
    return (categoryIdToName.get(String(categoryId)) || '').toLowerCase() === 'travel';
  };
}
